module.exports = __webpack_public_path__ + "static/media/BelindaSabatierMondjo.2b5f2054.svg";